/* eslint-disable max-len */
/* eslint-disable */
/* eslint-disable operator-linebreak */
/* eslint-disable implicit-arrow-linebreak */
import React, { useEffect, useState } from 'react';
import { RegularButton, SearchInput } from 'pg-ui-library';
import { SortOrder, TableColumn } from 'react-data-table-component';
import useDebounceSearchTerm from 'src/hooks/useDebounceSearchTerm';
import { DefaultTable } from 'src/components';
import { useTranslation } from 'react-i18next';
import Arrow from 'src/assets/arrow-left-black.svg';
import { useQuery } from '@tanstack/react-query';
import BenefitsService from 'src/services/benefits.service';
import { Select, MenuItem, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Box } from '@mui/material';
import { useTypedSelector } from 'src/hooks/useTypedSelector';
import {
  ArrowBack,
  ColumnTitle,
  Container,
  Header,
  HeaderItems,
  NavTextLink,
  ReportsContainer,
  SearchStyle,
} from './styles';

const columns: TableColumn<any>[] = [
  {
    name: <ColumnTitle>Worker ID</ColumnTitle>,
    selector: (row: any) => `${row.workerId}` || '',
    sortable: false,
    reorder: true,
    width: '160px',
  },

  {
    name: <ColumnTitle>Employee Name</ColumnTitle>,
    selector: (row: any) => `${row.firstName} ${row.lastName}` || '',
    sortable: false,
    reorder: true,
    width: '160px',
  },
  {
    name: <ColumnTitle>Birth Date</ColumnTitle>,
    selector: (row: any) => row.birthDate || '',
    sortable: false,
    reorder: true,
    width: '130px',
  },
  {
    name: <ColumnTitle>Gender</ColumnTitle>,
    selector: (row: any) => row.gender || '',
    sortable: false,
    reorder: true,
    width: '130px',
  },
  {
    name: <ColumnTitle>Hire Date</ColumnTitle>,
    selector: (row: any) => row.hireDate || '',
    sortable: false,
    reorder: true,
    width: '130px',
  },
  {
    name: <ColumnTitle>Rehire Date</ColumnTitle>,
    selector: (row: any) => row.rehireDate || '',
    sortable: false,
    reorder: true,
    width: '130px',
  },
  {
    name: <ColumnTitle>Termination Status</ColumnTitle>,
    selector: (row: any) => row.terminationDate || '',
    sortable: false,
    reorder: true,
    width: '130px',
  },
  {
    name: <ColumnTitle>Termination Date</ColumnTitle>,
    selector: (row: any) => row.terminationDateDate || '',
    sortable: false,
    reorder: true,
    width: '130px',
  },
  {
    name: <ColumnTitle>Residential ZIP Code</ColumnTitle>,
    selector: (row: any) => row.residentialZipCode || '',
    sortable: false,
    reorder: true,
    width: '130px',
  },
  {
    name: <ColumnTitle>Work Address</ColumnTitle>,
    selector: (row: any) => row.workZipCode || '',
    sortable: false,
    reorder: true,
    width: '130px',
  },
  {
    name: <ColumnTitle>Job</ColumnTitle>,
    selector: (row: any) => row.job || '',
    sortable: false,
    reorder: true,
    width: '180px',
  },
  {
    name: <ColumnTitle>Medical Plan</ColumnTitle>,
    selector: (row: any) => row.Medical_Plan_Election || '',
    sortable: false,
    reorder: true,
  },
  {
    name: <ColumnTitle>Medical Tier</ColumnTitle>,
    selector: (row: any) => row.Medical_Coverage_Tier || '',
    sortable: false,
    reorder: true,
  },
  {
    name: <ColumnTitle>Dental Plan</ColumnTitle>,
    selector: (row: any) => row.Dental_Plan_Election || '',
    sortable: false,
    reorder: true,
  },
  {
    name: <ColumnTitle>Dental Tier</ColumnTitle>,
    selector: (row: any) => row.Dental_Coverage_Tier || '',
    sortable: false,
    reorder: true,
  },
  {
    name: <ColumnTitle>Vision Plan</ColumnTitle>,
    selector: (row: any) => row.Vision_Plan_Election || '',
    sortable: false,
    reorder: true,
  },
  {
    name: <ColumnTitle>Vision Tier</ColumnTitle>,
    selector: (row: any) => row.Vision_Coverage_Tier || '',
    sortable: false,
    reorder: true,
  },
  {
    name: <ColumnTitle>Long Term Disability Plan</ColumnTitle>,
    selector: (row: any) => row.LongTermDisability_Plan_Election || '',
    sortable: false,
    reorder: true,
  },
  {
    name: <ColumnTitle>Long Term Disability Tier</ColumnTitle>,
    selector: (row: any) => row.LongTermDisability_Coverage_Tier || '',
    sortable: false,
    reorder: true,
  },
  {
    name: <ColumnTitle>Pay Rate</ColumnTitle>,
    selector: (row: any) => row.payRate || '',
    sortable: false,
    reorder: true,
  },
  {
    name: <ColumnTitle>Annual Equivalent</ColumnTitle>,
    selector: (row: any) => row.annualEquivalent || '',
    sortable: false,
    reorder: true,
  },
  {
    name: <ColumnTitle>Agreement</ColumnTitle>,
    selector: (row: any) => row.agreementTermId || '',
    sortable: false,
    reorder: true,
    width: '130px',
  },

  {
    name: <ColumnTitle>Dependent Name</ColumnTitle>,
    selector: (row: any) => <div title={row.dependentFirstName || ''}>{row.dependentFirstName || ''}</div>,
    sortable: true,
    sortField: 'dependentFirstName',
    reorder: true,
    width: '200px',
  },
  {
    name: <ColumnTitle>Dependent Date of Birth</ColumnTitle>,
    selector: (row: any) => <div title={row.dependentBirthDate || ''}>{row.dependentBirthDate || ''}</div>,
    sortable: true,
    sortField: 'dependentBirthDate',
    reorder: true,
    width: '370px',
  },
  {
    name: <ColumnTitle>Dependent SSN</ColumnTitle>,
    selector: (row: any) => <div title={row.dependentSSN || ''}>{row.dependentSSN || ''}</div>,
    sortable: true,
    sortField: 'dependentSSN',
    reorder: true,
    width: '320px',
  },
  {
    name: <ColumnTitle>Relationship</ColumnTitle>,
    selector: (row: any) => <div title={row.relationshipType || ''}>{row.relationshipType || ''}</div>,
    sortable: true,
    sortField: 'relationshipType',
    reorder: true,
    width: '320px',
  },
  {
    name: <ColumnTitle>Beneficiary First Name</ColumnTitle>,
    selector: (row: any) => <div title={row.beneficiaryFirstName || ''}>{row.beneficiaryFirstName || ''}</div>,
    sortable: true,
    sortField: 'dependentFirstName',
    reorder: true,
    width: '200px',
  },
  {
    name: <ColumnTitle>Beneficiary Date of Birth</ColumnTitle>,
    selector: (row: any) => row.beneficiaryBirthDate || '',
    sortable: true,
    sortField: 'dependentBirthDate',
    reorder: true,
    width: '370px',
  },
  {
    name: <ColumnTitle>Beneficiary SSN</ColumnTitle>,
    selector: (row: any) => row.beneficiarySSN || '',
    sortable: true,
    sortField: 'dependentSSN',
    reorder: true,
    width: '320px',
  },
  {
    name: <ColumnTitle>Beneficiary Percentage</ColumnTitle>,
    selector: (row: any) => row.percentage || '',
    sortable: true,
    sortField: 'percentage',
    reorder: true,
  },
];

export const WorkerEnrolledBenefitsOld: React.FC = () => {
  const { searchTerm, setSearchTerm } = useDebounceSearchTerm(500);
  const { t } = useTranslation();
  const { data: companies } = useTypedSelector(state => state.companies);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [sortBy, setSortBy] = useState('');
  const [companyId, setCompanyId] = useState('');
  const [sortDirection, setSortDirection] = useState('');
  const [eventType, setEventType] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [employeeClass, setEmployeeClass] = useState('');

  const [hasDatesInitialized, setHasDatesInitialized] = useState(false);

  const companyIdFromStore = useTypedSelector(state => state.config.data?.config?.selectedCompanyId) || '';

  // Define functions for calculating date limits
  const calculateMaxEndDate = (start: string): string => {
    if (!start) return '';
    const s = new Date(start);
    s.setDate(s.getDate() + 90);
    return s.toISOString().split('T')[0];
  };

  const calculateMinStartDate = (end: string): string => {
    if (!end) return '';
    const e = new Date(end);
    e.setDate(e.getDate() - 90);
    return e.toISOString().split('T')[0];
  };

  const [isReady, setIsReady] = useState(false);

  const [isDatesSet, setIsDatesSet] = useState(false);

  // Function to calculate 90 days before a date
  const calculateStartDate = (date: string) => {
    const end = new Date(date);
    end.setDate(end.getDate() - 90);
    return end.toISOString().split('T')[0];
  };

  // Set initial dates
  useEffect(() => {
    const today = new Date();
    const todayFormatted = today.toISOString().split('T')[0];
    setEndDate(todayFormatted); // Set today's date as the endDate

    const startFormatted = calculateStartDate(todayFormatted); // Calculate startDate
    setStartDate(startFormatted); // Set the startDate 90 days before the endDate

    setIsDatesSet(true); // Now the dates are set
  }, []);

  // Function to calculate the difference in days between two dates
  const diffInDays = (date1: string, date2: string) =>
    (new Date(date2).getTime() - new Date(date1).getTime()) / (1000 * 60 * 60 * 24);

  const handleStartDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newStart = e.target.value;
    if (endDate && diffInDays(newStart, endDate) > 90) {
      return;
    }
    setStartDate(newStart);
  };

  const handleEndDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newEnd = e.target.value;
    if (startDate && diffInDays(startDate, newEnd) > 90) {
      return;
    }
    setEndDate(newEnd);
  };

  const {
    data: benefitsItems,
    refetch,
    isLoading,
    isFetching,
  } = useQuery(
    [
      'benefits',
      { startDate, endDate, page, companyId, limit, searchTerm, sortBy, sortDirection, eventType, employeeClass },
    ],
    () => {
      console.log('API Call Params:', {
        startDate,
        endDate,
        page,
        companyId,
        limit,
        searchTerm,
        sortBy,
        sortDirection,
        eventType,
        employeeClass,
      });
      return BenefitsService.getWorkerEnrolledBenefitsOld({
        startDate,
        endDate,
        page,
        companyId,
        limit,
        search: searchTerm,
        sortBy,
        sortDirection,
        eventType,
        employeeClass,
      });
    },
    {
      enabled: isDatesSet && startDate !== '' && endDate !== '',
    }
  );

  useEffect(() => {
    refetch();
  }, [searchTerm, page, limit, sortBy, sortDirection, companyId, eventType, startDate, endDate, employeeClass]);

  const exportToExcel = () =>
    BenefitsService.getWorkerEnrolledBenefitsXLSLinkOld(
      eventType,
      startDate,
      endDate,
      companyId,
      searchTerm,
      employeeClass
    );

  const handlePageChange = (nPage: number) => {
    setPage(nPage);
  };

  const handlePerRowsChange = async (newLimit: number, nPage: number) => {
    setPage(nPage);
    setLimit(newLimit);
  };

  const handleSort = async (column: TableColumn<any>, newSortDirection: SortOrder) => {
    setSortBy(column.sortField as unknown as string);
    setSortDirection(newSortDirection);
  };

  const handleClearFilters = () => {
    setCompanyId('');
    setEventType('');
    setStartDate('');
    setEndDate('');
    setEmployeeClass('');
  };

  return (
    <Container>
      <Header>
        <HeaderItems>
          <NavTextLink to="/reports">
            <div style={{ marginTop: '22px' }}>
              <ArrowBack src={Arrow} />
            </div>
          </NavTextLink>
          {/* Filters moved outside the dialog and placed here */}
          <Box display="flex" alignItems="center" gap={2}>
            <SearchStyle style={{ marginTop: '22px' }}>
              <SearchInput
                value={searchTerm}
                placeholder="Search..."
                handleChange={event => setSearchTerm(event.target.value)}
              />
            </SearchStyle>
            <Box sx={{ width: '200px' }}>
              <p style={{ marginTop: '-5px', marginBottom: '5px' }}>Event Type</p>
              <Select
                value={eventType}
                onChange={e => setEventType(e.target.value)}
                displayEmpty
                sx={{
                  height: '40px',
                  fontSize: '16px',
                  padding: '5px',
                  '& .MuiSelect-select': {
                    padding: '10px',
                    minWidth: '150px',
                  },
                }}
              >
                <MenuItem value="">All</MenuItem>
                <MenuItem value="new_hire">New Hire</MenuItem>
                <MenuItem value="open_enrollment">Open Enrollment</MenuItem>
                <MenuItem value="qle">Qualifying Life Event</MenuItem>
              </Select>
            </Box>
            <Box sx={{ width: '320px' }}>
              <p style={{ marginTop: '-5px', marginBottom: '5px' }}>Company</p>

              <Select
                value={companyId}
                onChange={e => {
                  const selectedCompanyId = e.target.value;
                  const selectedCompany = companies?.companies?.find(company => company.id === selectedCompanyId);

                  if (selectedCompany) {
                    setEmployeeClass(selectedCompany.legalEntityId);
                  } else {
                    console.log('No company selected');
                    setEmployeeClass('');
                  }

                  setCompanyId(selectedCompanyId);
                }}
                displayEmpty
                sx={{
                  height: '40px',
                  fontSize: '16px',
                  padding: '10px',
                  '& .MuiSelect-select': {
                    padding: '10px',
                    minWidth: '250px',
                  },
                }}
              >
                <MenuItem value="">All</MenuItem>
                {companies?.companies?.map(company => (
                  <MenuItem key={company.id} value={company.id}>
                    {company.name}
                  </MenuItem>
                ))}
              </Select>
            </Box>

            <Box sx={{ width: '120px' }}>
              <p style={{ marginTop: '-5px', marginBottom: '5px' }}>Start Date</p>
              <TextField
                type="date"
                value={startDate}
                onChange={handleStartDateChange}
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  style: { fontSize: 14, padding: '10px' },
                  min: endDate ? calculateMinStartDate(endDate) : undefined,
                }}
                fullWidth
                sx={{ maxWidth: '120px' }}
              />
            </Box>
            <Box sx={{ width: '120px' }}>
              <p style={{ marginTop: '-5px', marginBottom: '5px' }}>End Date</p>
              <TextField
                type="date"
                value={endDate}
                onChange={handleEndDateChange}
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  style: { fontSize: 14, padding: '10px' },
                  max: startDate ? calculateMaxEndDate(startDate) : undefined,
                }}
                fullWidth
                sx={{ maxWidth: '120px' }}
              />
            </Box>
          </Box>

          <RegularButton onClick={handleClearFilters} style={{ margin: '4px', marginTop: '22px' }}>
            Clear Filters
          </RegularButton>

          <a href={exportToExcel()} download rel="noreferrer">
            <RegularButton style={{ margin: '4px', marginTop: '22px' }}>{t('global.form.exportExcel')}</RegularButton>
          </a>
        </HeaderItems>
      </Header>

      <ReportsContainer>
        <DefaultTable
          columns={columns}
          data={benefitsItems?.items || []}
          progressPending={isLoading || isFetching}
          pagination
          paginationServer
          paginationTotalRows={benefitsItems?.meta.totalItems || 0}
          onChangeRowsPerPage={handlePerRowsChange}
          onChangePage={handlePageChange}
          onSort={handleSort}
          sortServer
        />
      </ReportsContainer>
    </Container>
  );
};
